import { Link, Stack } from "@mui/material";
import { IDashboardContract } from "../../../../api/hooks/useContracts";
import { SearchStateLink } from "../../../../shared/layout/SearchStateLink";
import { generatePath } from "react-router-dom";
import { CONTRACTS_DETAIL_PATH } from "../../../../paths";

export const ContractNameCell = ({ contract }: { contract: IDashboardContract }) => {
  return (
    <Link
      component={SearchStateLink}
      sx={{ textDecoration: "none", color: "text.primary" }}
      to={generatePath(CONTRACTS_DETAIL_PATH, {
        id: contract.shared_uuid,
      })}
    >
      {getContractNames(contract)}
    </Link>
  );
};

function getContractNames(contract: IDashboardContract) {
  if (contract.supplier_contract_name && contract.consumer_contract_name) {
    return (
      <Stack lineHeight={1} py={2.5} gap={1}>
        <strong title={contract.supplier_contract_name}>{contract.supplier_contract_name}</strong>
        <span title={contract.consumer_contract_name}>{contract.consumer_contract_name}</span>
      </Stack>
    );
  }

  const title = contract.contract_display_name;
  return <strong title={title}>{title}</strong>;
}
